import { useCallback, useState } from "react";
import { useShallow } from "zustand/shallow";

import { useBoundStore } from "@/app/store";

export function useNotesTrashState() {
  const [selectedNotes, setSelectedNotes] = useState<Set<number>>(new Set());
  const [isSelectionMode, setIsSelectionMode] = useState(false);

  const { deletedNotes, deleteNote, restoreNote } = useBoundStore(
    useShallow((state) => ({
      deletedNotes: state.notes.deleted,
      deleteNote: state.notes.deleteNote,
      restoreNote: state.notes.restoreNote,
    }))
  );

  const clearSelection = useCallback(() => {
    setSelectedNotes(new Set());
    setIsSelectionMode(false);
  }, []);

  const handleRestoreSelected = useCallback(() => {
    selectedNotes.forEach((noteId) => {
      restoreNote(noteId);
    });
    clearSelection();
  }, [selectedNotes, restoreNote, clearSelection]);

  const handleDeleteSelected = useCallback(() => {
    selectedNotes.forEach((noteId) => {
      deleteNote(noteId);
    });
    clearSelection();
  }, [selectedNotes, deleteNote, clearSelection]);

  return {
    // State
    selectedNotes,
    setSelectedNotes,
    isSelectionMode,
    setIsSelectionMode,

    // Store data
    deletedNotes,
    deleteNote,
    restoreNote,

    // Handlers
    clearSelection,
    handleRestoreSelected,
    handleDeleteSelected,
  };
}
